/// <reference path="../../../typings/tsd.d.ts" /> 
class BaseEntity {
    entityAspect: breeze.EntityAspect;
    entityType: breeze.EntityType;
    public id;
    public lastUpdateUserName: string;
    public lastUpdateDate: Date;
}